import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../../shared/services/auth.service";
import {CreateCustomOperationMethodDto, CustomOperationMethodDto, UpdateCustomOperationMethodDto} from "../dtos/operation-method.dto";

export async function getAllOperations(navigate: NavigateFunction): Promise<CustomOperationMethodDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  const operations = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/custom-operation-method`,
    {headers: {Authorization: `Bearer ${token}`}})
    .then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch operations: ${response.statusText}`);
      }
      return await response.json() as CustomOperationMethodDto[]
    });
  return operations;
}

export async function getOperation(navigate: NavigateFunction, operationId: number): Promise<CustomOperationMethodDto> {
  const token = await getUserTokenOrRedirect(navigate)
  const operation = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/custom-operation-method/${operationId}`,
    {headers: {Authorization: `Bearer ${token}`}})
    .then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch operation: ${response.statusText}`);
      }
      return await response.json() as CustomOperationMethodDto
    });
  return operation;
}

export async function createOperation(navigate: NavigateFunction, operation: CreateCustomOperationMethodDto): Promise<CustomOperationMethodDto> {
  const token = await getUserTokenOrRedirect(navigate)
  const createdOperation = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/custom-operation-method`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(operation)
    }).then(async response => {
    if (!response.ok) {
      throw new Error(`Failed to create operation: ${response.statusText}`);
    }
      return await response.json() as CustomOperationMethodDto
  });
  return createdOperation;
}

export async function updateOperation(navigate: NavigateFunction, operationId: number, operation: UpdateCustomOperationMethodDto): Promise<CustomOperationMethodDto> {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/custom-operation-method/${operationId}`,
    {
      method: 'PATCH',
      body: JSON.stringify(operation),
      headers:
        {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
    })
    .then(async r => r.ok ? (await r.json()) as CustomOperationMethodDto : Promise.reject(r));

  return response;
}

export async function deleteOperation(navigate: NavigateFunction, operationId: number): Promise<void> {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/custom-operation-method/${operationId}`,
    {
      method: 'DELETE',
      headers:
        {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
    });
  if(!response.ok) {
    throw new Error(`Failed to delete operation: ${response.statusText}`);
  }
}

